import { Expose } from 'class-transformer';

export default class IssueInvoiceLateFeeError {
  billing_account_id: string[] = []
  late_fees: string[] = []
  @Expose({ name: '_schema' }) schema: string[] = []
}